import { apiGet, apiPut } from "@/services/api/client";

export interface ParentReportDraftContentV1 {
  observationNote: string;
  scoreNote: string;
  parentSuggestion: string;
  highlightEntryCodesByDomain: Record<string, string[]>;
  targetEntryCodesByDomain: Record<string, string[]>;
  activityEntryCodesByActivity: Record<string, string[]>;
}

export interface ParentReportDraft {
  assessmentId: string;
  contentSchemaVersion: "parent-report-v1";
  content: ParentReportDraftContentV1;
  version: number;
  createdByDisplayName?: string;
  updatedByDisplayName?: string;
  createdAt: string;
  updatedAt: string;
}

export async function fetchParentReportDraft(
  assessmentId: string,
): Promise<{ draft: ParentReportDraft | null }> {
  return apiGet(`/assessments/${encodeURIComponent(assessmentId)}/parent-report/draft`);
}

export async function saveParentReportDraft(
  assessmentId: string,
  content: ParentReportDraftContentV1,
  expectedVersion: number,
): Promise<ParentReportDraft> {
  return apiPut(`/assessments/${encodeURIComponent(assessmentId)}/parent-report/draft`, {
    content,
    expectedVersion
  });
}
